// extracted by mini-css-extract-plugin
module.exports = {"ChatWidget":"widget_ChatWidget__1yp3R","chatCard":"widget_chatCard__3SFmv","btn":"widget_btn__htOpb"};